const MOBILE_BREAKPOINT = '636';

const initFooter = () => {
	const footerComplex = document.querySelector( 'footer > ul.complex > li:first-child' );

	if ( !footerComplex )
	{
		return;
	}

	footerComplex.addEventListener( 'click', ( evt ) => {
		evt.target.closest( 'li' ).classList.toggle( 'open' );
	} );

	window.addEventListener( 'resize', () => {
		if ( window.innerWidth >= MOBILE_BREAKPOINT )
		{
			footerComplex.classList.remove( 'open' );
		}
	} );
};

export {
	initFooter,
};
